var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "document-viewer" }, [
      _c("iframe", {
        attrs: {
          id: "pdfViewer",
          src: "./pdfjs/web/viewer.html",
          title: "PDF Viewer"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }